import { SceneService } from './../../components/scene.service';
import { VRMLModel } from './../../model';
import { Component } from '@angular/core';
import { Scene, Vector3 } from 'three';
import { EntityComponent } from '../../components/share/entity-component';
import { VRMLLoader } from '../VRMLLoader';
import { RendererService } from '../../components/renderer.service';

@Component({
  selector: 'ng3-vrml-loader',
  templateUrl: './vrml-loader.component.html',
  styleUrls: ['./vrml-loader.component.css'],
})
export class VrmlLoaderComponent extends EntityComponent<VRMLModel> {
  constructor(sceneService: SceneService, renderer: RendererService) {
    super(sceneService, renderer);
  }
  createEntity(model: VRMLModel) {
    const loader = new VRMLLoader();
    let result = new Scene();
    loader.load('/home/vince/source/imageW/ImageW/projects/image-w/resource/MedicalShow2.vrml', scene => {
      scene.position.copy(model.center);
      result = scene;
    })
    return result;

  }
  updateEntity(model: VRMLModel, entity: Scene) {
    entity.position.copy(model.center);
    return entity;
  }

  defaultModel() {
    return new VRMLModel(
      new Vector3(0,0,0)
    );
  }



}
